// Constants for different requests for current reducer
export default {
  visitLog: 'VISIT_LOG',
  visitReportLink: 'VISIT_REPORT_LINK'
};
